<template>
    <div>
        <div class="bg-light header">
            <div class="container">
                <nav id="nav" class="navbar fixed-top navbar-expand-lg navbar-light bg-light">
                    <div class="container">
                        <router-link to="/" class="navbar-brand">
                            <img alt="AirPro Auggie Management" src="@/shared/assets/logo-small.png" />
                        </router-link>
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle Menu">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div id="navbarMain" class="collapse navbar-collapse">
                            <ul class="navbar-nav mb-2 mb-lg-0">
                                <li v-show="UserRoles.hasAny(['AuggieSessionView', 'AuggieSessionEdit'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/Connect">Connect</router-link>
                                </li>
                                <li v-show="UserRoles.hasAny(['AuggieVehicleView', 'AuggieVehicleTargetBrightnessEdit', 'AuggieVehicleEdit'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/Configuration">Configuration</router-link>
                                </li>
                                <li v-show="UserRoles.hasAny(['AuggieDeviceView', 'AuggieDeviceEdit'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/Devices">Devices</router-link>
                                </li>
                                <li v-show="UserRoles.hasAny(['AuggiePackageView', 'AuggiePackageEdit'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/Packages">Packages</router-link>
                                </li>
                                <li v-show="UserRoles.hasAny(['AuggieCalibrationView'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/Calibrations">Calibrations</router-link>
                                </li>
                                <li v-show="UserRoles.hasAny(['AuggieCameraImageMetricsView'])" class="nav-item l0">
                                    <router-link class="nav-link" to="/CameraImages">Camera Images</router-link>
                                </li>
                            </ul>
                            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                                <li v-show="identity.isAuthenticated" class="nav-item">
                                    <a class="nav-link" :href="settingsUrl()">
                                        <span class="hello me-2">Hello</span>
                                        <span class="username" data-bs-toggle="tooltip" data-bs-placement="bottom" v-bind:title="userName">{{ userName }}</span>!
                                        <online-status class="ms-3"/>
                                    </a>
                                </li>
                                <li v-show="identity.isAuthenticated" class="nav-item">
                                    <router-link class="nav-link" to="/AccountLogoff">Log off</router-link>
                                </li>
                                <li v-show="!identity.isAuthenticated" class="nav-item">
                                    <a href="#" class="nav-link" @click.prevent="identity.signIn()">Log in</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <div class="container environment">
            <div v-if="environmentName" class="alert alert-danger">
                {{ environmentName }}
            </div>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .header {
        height: auto;
    }
    #nav {
        padding: .5em;
        border-bottom: 2px solid var(--bs-primary);
    }
    .navbar-brand {
        img {
            max-height:40px;
        }
    }
    .nav-item.l0:hover {
        background: var(--bs-gray-300);
    }
    .userNameEntry {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        align-items: center;
        .hello {
            display:inline-block;
        }
        .username {
            display:inline-block;
        }
    }

    .environment {
        margin-top:5.5rem;
        text-align:center;
        font-size:1.2rem;
        font-weight: bolder;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { CurrentUser } from "@/identity";
import OnlineStatus from "./OnlineStatus.vue";
import Globals from "@/support/Globals";

export default defineComponent({
    components: {
        OnlineStatus,
    },
    data() {
        return {
            environmentName: Globals.GetEnvironment(),
        };
    },
    computed: {
        userName(): string | null {
            return CurrentUser.userProfile?.name || null;
        },
    },
    methods: {
        settingsUrl(): string {
            const loc = window.location;
            const appUrl = `${loc.protocol}//${loc.host}${import.meta.env.BASE_URL}`;
            return Globals.IdentityUrl(`${import.meta.env.VITE_Identity_Settings}${appUrl}`);
        },
    },
});
</script>
